
import type { loader } from "./site-layout";
import SocialLinksSection from "./social-links";
import { Link,  useLoaderData,  useRouteLoaderData,  type LoaderFunctionArgs } from "react-router";
//import type { Route as SiteLayout } from "~/layout/public/+types/site-layout";



export default function FooterSection() {
  const data = useLoaderData<typeof loader>();
  
    return (
        <footer id="footer">
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 footer-contact">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <h3><div className="logoFooter">Constellation<br /><div>training</div></div></h3>
                                    <p className="d-none d-lg-inline">
                                        <strong>Phone:</strong> {data.phoneNumber}<br />
                                        <strong>Email:</strong> {data.contactEmail}<br />
                                    </p>
                                </div>
                                <div className="col-lg-3 col-md-6 col-sm-12">
                                    <p>
                                        <strong>London</strong><br />
                                        Tooting Works Business Centre<br />
                                        89 Bickersteth Rd<br />
                                        London, SW17 9SH <br /><br />
                                    </p>
                                    <p className="d-lg-none d-md-inline">
                                        <strong>Phone:</strong>&nbsp;
                                        <a href={`tel:${data.machinePhoneNumber}`} className="d-inline d-lg-none">
                                            {data.phoneNumber}
                                        </a>
                                        <span className="d-none d-lg-inline">
                                            {data.phoneNumber}
                                        </span><br />
                                        <strong>Email:</strong> {data.contactEmail}<br />
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-2 col-md-6 footer-links">
                            <h4>Useful Links</h4>
                            <ul>
                                <li><i className="bx bx-chevron-right"></i> <Link to="/">Home</Link> </li>
                                <li><i className="bx bx-chevron-right"></i> <Link to="/about">About</Link> </li>
                                <li><i className="bx bx-chevron-right"></i> <Link to="/courses">Courses</Link> </li>
                                <li><i className="bx bx-chevron-right"></i> <Link to="/contact">Contact</Link> </li>
                                <li><i className="bx bx-chevron-right"></i> <Link to="/privacy">Privacy</Link> </li>
                            </ul>
                        </div>

                        <div className="col-lg-3 col-md-6 footer-links">
                            <h4>Our Course</h4>
                            <ul>
                                <li><i className="bx bx-chevron-right"></i> <Link to="/courses/first-aid">First Aid</Link> </li>
                                <li><i className="bx bx-chevron-right"></i> <Link to="/courses/mental-health-first-aid">Mental Health First Aid</Link> </li>
                                <li><i className="bx bx-chevron-right"></i> <Link to="/courses/health-safety">Health & Safety</Link> </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container d-md-flex py-4">

                <div className="me-md-auto text-center text-md-start">
                    <div className="copyright">
                        &copy; Copyright <strong><span className="PC">Constellation</span><span className="train">training</span></strong> Ltd. All Rights Reserved<br />

                    </div>
                </div>
                <SocialLinksSection />
            </div>
        </footer>
    )
}